module.exports = __webpack_public_path__ + "assets/img/simply-Brand_01.bd1ad743.png";